import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { changeMachinePassword } from "data/server_apis/vendingServices";

const initialState = {
  changingPassword: {},
};

export const changePasswordThunk = createAsyncThunk(
  "password/change",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await changeMachinePassword(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const machineOpsSlice = createSlice({
  name: "machine_ops",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changePasswordThunk.pending, (state, action) => {
        state.changingPassword = {
          loading: true,
          error: false,
          success: false,
        };
      })
      .addCase(changePasswordThunk.rejected, (state, action) => {
        state.changingPassword = {
          loading: false,
          error: true,
          success: false,
          errorMessage: action.payload,
        };
      })
      .addCase(changePasswordThunk.fulfilled, (state, action) => {
        state.changingPassword = {
          loading: false,
          error: false,
          success: true,
        };
      });
  },
});

export const {} = machineOpsSlice.actions;

export default machineOpsSlice.reducer;
